/* global TweenMax TimelineMax Sine Circ Quad Quint Expo:true  */

import Viewport from '@vaersaagod/tools/Viewport';
import Dispatch from '@vaersaagod/tools/Dispatch';
import $ from '@vaersaagod/tools/Dom';
import * as Events from '../lib/events';

export default el => {
    const OFFSET_BUFFER = 10;
    const OFFSET_TOP = 30;

    let isOpen = false;
    let openTimeline;
    let closeTimeline;
    let scrollingLocked = false;
    let lastTop = Viewport.scroll.top;
    let headerShowing = true;
    let scrollBeforeLock = 0;

    const dom = $(el);
    const $body = $('body');
    const openToggle = dom.find('[data-open]');
    const openIcon = openToggle.find('[data-icon]');
    const openText = openToggle.find('[data-text]');
    const openLines = openIcon.find('span');
    const closeToggle = dom.find('[data-close]');
    const closeIcon = closeToggle.find('[data-icon]');
    const closeText = closeToggle.find('[data-text]');
    const closeLines = closeIcon.find('span');

    const open = () => {
        if (!isOpen) {
            isOpen = true;

            openTimeline = new TimelineMax({
                autoRemoveChildren: true
            })
                .addLabel('start')
                .set(closeLines.nodes, { rotationZ: 0, opacity: 0 })
                .set(closeText.get(0), { y: 20, opacity: 0 })
                .set(closeToggle.get(0), { display: 'block' })
                .to(openLines.get(0), 0.35, { y: 11, ease: Quint.easeInOut }, 'start')
                .to(openLines.get(2), 0.35, { y: -11, ease: Quint.easeInOut }, 'start')
                .addLabel('middle')
                .set(closeLines.nodes, { opacity: 1 }, 'middle-=0.1')
                .set(openLines.nodes, { opacity: 0 }, 'middle-=0.1')
                .to(closeLines.get(0), 0.35, { rotationZ: 45, ease: Quint.easeOut }, 'middle-=0.1')
                .to(closeLines.get(1), 0.35, { rotationZ: -45, ease: Quint.easeOut }, 'middle-=0.1')
                .to(openText.get(0), 0.75, { y: -20, opacity: 0, ease: Quint.easeInOut }, 'middle-=0.35')
                .to(closeText.get(0), 0.5, { y: 0, opacity: 1, ease: Quint.easeOut }, 'middle')
                .set(openToggle.get(0), { display: 'none' });
        }
    };

    const close = () => {
        if (isOpen) {
            isOpen = false;
            openTimeline.pause();

            closeTimeline = new TimelineMax({
                autoRemoveChildren: true
            })
                .addLabel('start')
                .set(openToggle.get(0), { display: 'block' })
                .to(closeText.get(0), 0.75, { y: 20, opacity: 0, ease: Quint.easeInOut }, 'start')
                .to(openText.get(0), 0.5, { y: 0, opacity: 1, ease: Quint.easeOut }, 'start+=0.35')
                .to(closeLines.get(0), 0.35, { rotationZ: 0, ease: Quint.easeInOut }, 'start+=0.15')
                .to(closeLines.get(1), 0.35, { rotationZ: 0, ease: Quint.easeInOut }, 'start+=0.15')
                .addLabel('middle', 'start+=0.4')
                .set(closeLines.nodes, { opacity: 0 }, 'middle')
                .set(openLines.nodes, { opacity: 1 }, 'middle')
                .to(openLines.get(0), 0.35, { y: 0, ease: Quint.easeOut }, 'middle')
                .to(openLines.get(2), 0.35, { y: 0, ease: Quint.easeOut }, 'middle')
                .set(closeToggle.get(0), { clearProps: 'all' })
                .set(openToggle.get(0), { clearProps: 'all' });
        }
    };

    const emitMenuOpen = () => {
        Dispatch.emit(Events.MENU_OPEN);
    };

    const emitMenuClose = () => {
        Dispatch.emit(Events.MENU_CLOSE);
    };

    const onOpenClick = e => {
        e.preventDefault();
        emitMenuOpen();
        scrollingLocked = true;
    };

    const onCloseClick = e => {
        e.preventDefault();
        emitMenuClose();
        scrollingLocked = false;
    };

    const show = () => {
        if (!headerShowing) {
            console.log('Header.show');
            headerShowing = true;
            TweenMax.to(el, 0.35, { yPercent: 0, ease: 'Quad.easeOut' });
            // TweenMax.to(this.bg, 0.35, { yPercent: 0, ease: 'Quad.easeOut' });
        }
    };

    const hide = () => {
        if (headerShowing) {
            console.log('Header.hide');
            headerShowing = false;
            TweenMax.to(el, 0.35, { yPercent: -100, ease: 'Quad.easeIn' });
            // TweenMax.to(this.bg, 0.35, { yPercent: -100, ease: 'Quad.easeIn' });
        }
    };

    const onScroll = () => {
        if (!scrollingLocked) {
            const top = Viewport.scroll.top;
            if (Math.abs(top - lastTop) > OFFSET_BUFFER) {
                const isScrollingUp = top < lastTop;

                if (isScrollingUp) {
                    show();
                    // this.toggleTransparency(this.hasTransparent && !(this.shouldBeTransparent(top) === this.isTransparent));
                    // this.toggleSize(top < OFFSET_TOP);
                } else if (top > OFFSET_TOP) {
                    hide();
                    // this.toggleSize(false);
                }

                lastTop = top;
            }
        }
    };

    // const lockScrolling = () => {
    //     if (!scrollingLocked) {
    //         Dispatch.emit(Events.SCROLL_LOCKED);
    //         const scrollbarWidth = Viewport.width - $body.width();
    //         scrollBeforeLock = Viewport.scrollTop;
    //
    //         if (scrollbarWidth > 0) {
    //             TweenMax.set($body.get(0), { width: this.$body.width() });
    //             TweenMax.set(this.$menuWrap.get(0), { width: Viewport.width });
    //
    //             if (Viewport.breakpoint.size < 1250) {
    //                 TweenLite.set([this.$searchTrigger.get(0), this.$toggles.get(0), this.$toggles.get(1)], { right: `+=${scrollbarWidth}` });
    //             } else {
    //                 TweenLite.set(this.$el.get(0), { width: this.$body.width() });
    //             }
    //         }
    //
    //         TweenLite.set(this.$body.get(0), { overflow: 'hidden' });
    //         // Viewport.lockScrolling();
    //     }
    // };
    //
    // const unlockScrolling = () => {
    //
    // };

    const onScrollLock = () => {
        scrollingLocked = true;
    };

    const onScrollUnlock = () => {
        scrollingLocked = false;
    };

    const init = () => {
        Dispatch.on(Events.MENU_OPEN, open);
        Dispatch.on(Events.MENU_CLOSE, close);
        Dispatch.on(Events.SCROLL_LOCKED, onScrollLock);
        Dispatch.on(Events.SCROLL_UNLOCKED, onScrollUnlock);
        dom.on('click', '[data-open]', onOpenClick);
        dom.on('click', '[data-close]', onCloseClick);
        Viewport.on('scroll', onScroll);
    };

    const destroy = () => {
        dom.off('click');
        Dispatch.off(Events.MENU_OPEN, open);
        Dispatch.off(Events.MENU_CLOSE, close);
        Dispatch.off(Events.SCROLL_LOCKED, onScrollLock);
        Dispatch.off(Events.SCROLL_UNLOCKED, onScrollUnlock);
        Viewport.off('scroll', onScroll);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/Header.js